var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"card blocked-ui"},[_c('div',{staticClass:"card-body c-content"},[_c('div',[_c('i',{staticClass:"ic-alert ic-danger h-240p"})]),_c('h1',[_vm._v("ACCÈS NON AUTORISÉ")])])])
}]

export { render, staticRenderFns }